import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {logout} from '../../../../store/actions/userActions';
import { useTheme } from '@mui/material/styles';
import {
    Box,
    Chip,
    Typography
} from '@mui/material';


// assets
import { IconLogout } from '@tabler/icons';

const ProfileSection = ({loading}) => {
    const dispatch = useDispatch();

    const logoutHandler = async () => {
        try {
            await dispatch(logout());
            // Always navigate to login page after logout
            navigate('/login');
        } catch (error) {
            console.error('Logout failed:', error);
            // Still navigate to login page even if logout fails
            navigate('/login');
        }
    };

    const theme = useTheme();
    const navigate = useNavigate();

    return (
        <>
            <Chip
                sx={{
                    height: '48px',
                    alignItems: 'center',
                    borderRadius: '27px',
                    transition: 'all .2s ease-in-out',
                    borderColor: theme.palette.primary.light,
                    backgroundColor: theme.palette.primary.light,
                    '&:hover': {
                        borderColor: theme.palette.error.main,
                        background: `${theme.palette.error.main}!important`,
                        color: theme.palette.background.paper,
                        '& svg': {
                            stroke: theme.palette.background.paper
                        }
                    },
                    '& .MuiChip-label': {
                        lineHeight: 0
                    }
                }}
                label={
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <IconLogout stroke={1.5} size="1.3rem" color={theme.palette.primary.main} />
                        {loading && 
                            <Typography variant="body2" sx={{ ml: 1, color: theme.palette.primary.main }}>
                                Logging out...
                            </Typography>
                        }
                    </Box>
                }
                variant="outlined"
                onClick={logoutHandler}
                color="primary"
                disabled={loading}
            />
        </>
    );
};

export default ProfileSection;
